module.exports = __webpack_public_path__ + "img/picture_viptk03.430c2919.png";